export enum ActionTypes {
  GetMarketingCampaignsSubscription = 'getMarketingCampaignsSubscription',
  GetMarketingCampaignsSubscriptionSuccess = 'getMarketingCampaignsSubscription.success',
  GetMarketingCampaignsSubscriptionFailure = 'getMarketingCampaignsSubscription.failure',
}
